import { User } from "../@core/data/users";

export default class Feedback {
  id?: string;
  category?: string;
  title?: string;
  description?: string;

  sourceType?: string; //video/images/document
  content?: string; //document
  videoUrl?: string; //video
  imagesUrl?: string[]; //images

  tags?: string[];
  status?: number;

  noLiked?: number;
  noComment?: number;

  //Moderator
  isReviewed?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  approvedBy?: string;
  approvedAuthor?: User;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
